import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsightsActive = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#0517f8",
		fillRule: "evenodd",
		stroke: "#0517f8",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M11.85 1.946a6.32 6.32 0 0 1 5.301 5.301.835.835 0 0 1-.831.947h-4.584a.834.834 0 0 1-.834-.833V2.777c0-.505.449-.906.948-.831M15.988 14.658c.599-.81 1.009-1.767 1.165-2.808a.835.835 0 0 0-.832-.947h-3.406a.833.833 0 0 0-.59 1.423l2.41 2.409c.355.354.953.326 1.253-.077M7.258 5.555a6.327 6.327 0 0 0-5.26 7.518c.481 2.473 2.48 4.462 4.954 4.933 1.876.357 3.64-.116 4.993-1.115.405-.3.436-.9.08-1.255L8.44 12.049a.83.83 0 0 1-.245-.589V6.385c0-.5-.44-.903-.936-.83",
		clipRule: "evenodd"
	})
});
export default SvgInsightsActive;
